import React from "react";
import {SignOutButton, useUser} from "@clerk/clerk-react";
import styles from "./Header.module.css"

export const Header: React.FC = () => {
    const {user} = useUser();
    const displayName = user?.fullName || [user?.firstName, user?.lastName].filter(Boolean).join(" ") || user?.username || "User";
    const initials = displayName
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map(word => word[0]?.toUpperCase() || "")
        .join("");

    return <div className={styles.wrapper}>
        <div className={styles.rightSection}>
            <div className={styles.profileContainer}>
                {user?.imageUrl ? (
                    <img className={styles.avatarImage} src={user.imageUrl} alt={`${displayName} avatar`}/>
                ) : (
                    <div className={styles.avatarFallback}>{initials || "U"}</div>
                )}
                <span className={styles.userName}>{displayName}</span>
            </div>
            <SignOutButton redirectUrl="/sign-in">
                <button className={styles.logoutButton}>Logout</button>
            </SignOutButton>
        </div>
    </div>
}
